<nz-layout class="height-wrapper" [dir]="i18nService.dir" *ngIf="mode === 'full'">
  <hw-drawer [closable]="false" [width]="500" [visible]="drawerOpen" (hwClose)="toggleDrawer()">
    <div class="drawer drawer-searh">
      <div class="drawer-header">
        <h1>Otsing</h1>
      </div>

      <div class="drawer-content">
        <div class="search-field">
          <nz-input-group [nzSuffix]="suffixTemplate">
            <input type="text" nz-input placeholder="Sisesta otsingusõna" />
          </nz-input-group>
          <ng-template #suffixTemplate><i title="Puhasta väli" nz-icon nzType="close"></i></ng-template>
        </div>

        <div class="search-noresults">
          <div class="illustration"><img src="assets/img/search_empty.svg" alt="" /></div>
          <p>Ühtegi vastet märksõnale ei leitud.</p>
        </div>

        <div class="search-results">
          <!-- SEARCH ITEM -->
          <dl class="search-item">
            <dt>
              Viimati otsitud <a href="#">Vaata kõiki<i nz-icon nzType="right" nzTheme="outline"></i></a>
            </dt>
            <dd>
              <a href="#">
                <div class="search-illustration"><img alt="" src="assets/img/document.png" /></div>
                <div class="search-content">
                  Raviarve 18-01
                  <span class="meta-info">13.10.10</span>
                  <span class="meta-icon"></span>
                </div>
              </a>
            </dd>

            <dd>
              <a href="#">
                <div class="search-illustration"><img alt="" src="assets/img/female-thumb.gif" /></div>
                <div class="search-content">
                  TUL 18-1234. Päi-Läänemets, Katrin
                  <span class="meta-info"
                    >30.07.1972 (46)<span class="meta-icon"
                      ><img class="icon" alt="Naissoo sümbol" src="assets/img/female.svg" /></span
                  ></span>
                </div>
              </a>
            </dd>

            <dd>
              <a href="#">
                <div class="search-illustration"><img alt="" src="assets/img/task.png" /></div>
                <div class="search-content">
                  Päi-Läänemets, Katrin
                  <span class="meta-info">13.10.18 kell 12:00<span class="meta-icon"></span></span>
                </div>
              </a>
            </dd>
          </dl>
          <!-- //SEARCH ITEM -->

          <!-- SEARCH ITEM -->
          <dl class="search-item">
            <dt>
              Viimati vaadatud dokumendid <a href="#">Vaata kõiki<i nz-icon nzType="right" nzTheme="outline"></i></a>
            </dt>
            <dd>
              <a href="#">
                <div class="search-illustration"><img alt="" src="assets/img/document.png" /></div>
                <div class="search-content">
                  Raviarve 18-01
                  <span class="meta-info">13.10.10<span class="meta-icon"></span></span>
                </div>
              </a>
            </dd>

            <dd>
              <a href="#">
                <div class="search-illustration"><img alt="" src="assets/img/document.png" /></div>
                <div class="search-content">
                  Raviarve 18-01
                  <span class="meta-info">13.10.10<span class="meta-icon"></span></span>
                </div>
              </a>
            </dd>
          </dl>
          <!-- //SEARCH ITEM -->
        </div>

        <div class="search-links">
          <ul>
            <li><i nz-icon nzType="right-square" nzTheme="fill"></i><a href="#">Otsi patsiente</a></li>
            <li><i nz-icon nzType="right-square" nzTheme="fill"></i><a href="#">Otsi vastuvõtte</a></li>
            <li><i nz-icon nzType="right-square" nzTheme="fill"></i><a href="#">Otsi dokumente</a></li>
          </ul>
        </div>
      </div>
    </div>
    <!--    <div class="drawer-footer">
      <button type="button" (click)="toggleDrawer()" class="ant-btn"><span>Close</span></button>
    </div>-->
  </hw-drawer>

  <nz-sider
    class="sidebar-wrapper"
    [nzCollapsed]="!sidebarState.content"
    [nzWidth]="sidebarState.width"
    [nzCollapsedWidth]="50">
    <span class="environment-name" *ngIf="envLabel && envLabel !== ''">{{ envLabel }}</span>

    <!-- SIDEBAR MENU -->
    <div class="sidebar-menu">
      <ul>
        <li>
          <a
            class="item-logo"
            [ngClass]="{ active: sidebarState.content === 'user-menu' }"
            title="{{ 'core.sidebar-items.user-menu.title' | translate }}"
            id="user-menu"
            (click)="selectItem($event)">
            <hw-heda-logo></hw-heda-logo>
            <span class="sr-only">HEDA</span>
          </a>
        </li>
        <li>
          <a
            class="item-apps"
            [ngClass]="{ active: sidebarState.content === 'navigation' }"
            title="{{ 'core.sidebar-items.navigation.title' | translate }}"
            id="navigation"
            (click)="selectItem($event)"></a>
        </li>
        <!--
        <li>
          <a class="item-search" [ngClass]="{'active': drawerOpen}"
             title="{{'core.sidebar-items.search.title' | translate}}" id="search" (click)="selectItem($event)"></a>
        </li>
        -->
        <li>
          <hw-dropdown
            *ngIf="!!videoCallService.call"
            [overlayStyle]="{ left: '50px', top: '-30px' }"
            (click)="videoCallService.maximize()">
            <ng-template #buttonTemplate><a class="item-ongoing-call"></a></ng-template>
            <a *hwDropdownItem (click)="videoCallService.hangup()">{{ 'core.videochat.hangup' | translate }}</a>
            <a *hwDropdownItemIf="videoCallService.minimized" (click)="videoCallService.maximize()">{{
              'core.videochat.maximize' | translate
            }}</a>
            <ng-container *ngFor="let a of videoCallService.actions">
              <a *hwDropdownItem (click)="a.action(videoCallService.call)">{{ a.label | translate }}</a>
            </ng-container>
          </hw-dropdown>
        </li>
      </ul>
      <ul>
        <li class="item-notifications-wrapper no-patient-selected">
          <a
            class="item-notifications"
            [ngClass]="{ active: selectedItemId === 'notifications' }"
            title="{{ 'core.sidebar-items.notifications.title' | translate }}"
            id="notifications"
            (click)="selectItem($event)"></a>
        </li>
        <li class="item-account-settings-wrapper">
          <a
            *ngIf="authContext.userInfo"
            class="item-account-settings"
            [ngClass]="{ active: sidebarState.content === 'account-settings' }"
            title="{{ 'core.sidebar-items.acc-settings.title' | translate }}"
            id="account-settings"
            (click)="selectItem($event)">
            <div class="initials-wrapper">
              <div class="name-initials">{{ authContext.userInfo.user?.name | format : initials }}</div>
            </div>
          </a>
        </li>
        <li class="item-help-wrapper" *ngIf="!envLabel === 'DEV'">
          <a
            class="item-help"
            [ngClass]="{ active: selectedItemId === 'help' }"
            title="{{ 'core.sidebar-items.help.title' | translate }}"
            id="help"
            (click)="selectItem($event)"></a>
        </li>
        <li *ngIf="envLabel === 'DEV'">
          <a (click)="bugDebug()"><hw-icon code="bug"></hw-icon></a>
        </li>
      </ul>
    </div>

    <!-- SIDEBAR CONTENT -->
    <div class="sidebar-content">
      <div class="pin-wrapper">
        <hw-pin (onPin)="pinMenu($event)" *ngIf="sidebarState.content"></hw-pin>
      </div>
      <hw-sidebar-menu
        style="display: {{ sidebarState.content === 'navigation' ? 'block' : 'none' }}"></hw-sidebar-menu>
      <hw-user-menu
        class="flex-column flex-column--full-height"
        *ngIf="sidebarState.content === 'user-menu'"></hw-user-menu>
      <hw-sidebar-account-settings *ngIf="sidebarState.content === 'account-settings'"></hw-sidebar-account-settings>
    </div>
  </nz-sider>

  <nz-layout *ngIf="initialized">
    <div class="height-wrapper">
      <router-outlet></router-outlet>
    </div>
  </nz-layout>
</nz-layout>

<nz-layout *ngIf="mode === 'iframe'">
  <div class="height-wrapper">
    <router-outlet></router-outlet>
  </div>
</nz-layout>

<hw-notification></hw-notification>
<hw-version-update></hw-version-update>
<hw-video-call-overlay></hw-video-call-overlay>
